<div class="ct-toolbar">
  <div class="title-block">
    <div class="title-row">
      <a
        class="back-btn"
        [routerLink]="backLink()"
        [attr.aria-label]="'aiMarketing.back' | t"
        [title]="'aiMarketing.back' | t"
      >
        <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
      </a>
      <h2>{{ titleKey() | t }}</h2>
    </div>
    @if (subtitleKey()) {
      <p class="subtitle">{{ subtitleKey()! | t }}</p>
    }
  </div>
  <ng-content select="[toolbarActions]" />
</div>
